import { isServer } from '@sitecore-jss/sitecore-jss/utils';

import { DEFAULT_DATA_LAYER, useDataLayerDefaultProps, type DataLayerType } from './defaultProps';
import { fillEmptyValues } from './utils';

export const useRegisterDataLayerAction = (dataLayerType: DataLayerType = DEFAULT_DATA_LAYER) => {
  const defaultGlobalProps = useDataLayerDefaultProps(dataLayerType);

  return (data: Record<string, unknown>): Record<string, unknown>[] | undefined => {
    if (typeof globalThis !== 'undefined' && !isServer()) {
      globalThis.dataLayer = globalThis?.dataLayer || [];

      const normalizedData = fillEmptyValues({
        ...defaultGlobalProps?.defaultGlobalProps,
        ...data,
      });

      globalThis.dataLayer.push(normalizedData);

      return globalThis.dataLayer;
    }
  };
};
